import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse, ITecnico } from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class TecnicoService {
  private readonly baseURL = '/Tecnico';
  constructor(private httpClient: HttpClient) {}

  getTecnico() {
    return this.httpClient.post<IApiResponse<ITecnico[]>>(this.baseURL, {});
  }
}
